import './globals.css';
import App from './App.svelte';

import * as Sentry from "@sentry/svelte";
import { BrowserTracing } from "@sentry/tracing";

if (import.meta.env.MODE != 'development') {
  Sentry.init({
    dsn: "https://cf112d1f43ff37cb5ab8b6e7793e0863@o4504492294995968.ingest.us.sentry.io/4511354722320384",
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}

const app = new App({
  target: document.getElementById('app'),
})

export default app
